import { DownloadState, ExportState } from '@data-access/downloads-exports';

export const initialExportState: ExportState = {
  errorMessage: '',
  exportsData: {
    data: [],
    status: [],
    total: 0,
  },
  fileName: '',
  isDialogOpen: false,
  status: 'idle',
};

export const initialDownloadState: DownloadState = {
  downloadsData: {
    data: [],
    status: [],
    total: 0,
  },
  errorMessage: '',
  fileName: '',
  isDialogOpen: false,
  status: 'idle',
};
